import { render, staticRenderFns } from "./TabLink.vue?vue&type=template&id=07569bda&"
import script from "./TabLink.vue?vue&type=script&lang=js&"
export * from "./TabLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports